var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"full-height",staticStyle:{"border":"0"},attrs:{"src":"https://cdc.ennovagroup.it/demo_cdc/home.php"}})])}]

export { render, staticRenderFns }